import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import {
  Container,
  Row,
  Col,
  Table,
  Card,
  CardBody,
} from "reactstrap"
import CardItem from "./CardItem" 
import ModalForm from "./ModalForm"
import { useSelector } from "react-redux"
import CountriesService from "services/Admin/CountriesService"
import SystemPaginator from "components/Common/SystemPaginator/SystemPaginator"

const CountriesPage = () => {
  const AuthData = useSelector(state => state.Auth)
  const isExist = (data) => (AuthData.permissions.includes(data) || AuthData.email === "admin@meras.com")
  const countriesService = new CountriesService()
  const [modal, setModal] = useState(false)
  const [editObj, setEditObj] = useState(null)
  const [add, setAdd] = useState(true)
  const [search, setSearch] = useState("")
  const [pageNum, setPageNum] = useState(1)
  const [searchWord, setSearchWord] = useState("")
  const [list, setList] = useState([])
  const [active, setActive] = useState("all")
  const [filtersParams, setFilterParams] = useState(null)
  const [shouldGetData, setShouldGetData] = useState(false)
  const [pageOptions, setPageOptions] = useState({
    sizePerPage: 10,
    totalSize: 1,
  })

  const addHandler = () => {
    setAdd(true)
    setEditObj(null)
    toggle()
  }
  const toggle = () => {
    setModal(!modal)
  }

  const OnSearchChange = (e) => {
    const val = e.target.value
    setSearch({
      searchWord: val,
      searchId: ""
    })
  }

  const OnSearchIdChange = (e) => {
    const val = e.target.value
    setSearch({
      searchWord: "",
      searchId: val
    })
  }
  useEffect(() => {

    // const timeoutId = setTimeout(() => {
      const params = {}
      if (active != 'all') params['status'] = active === "active" ? 1 : 0
      if (!!search?.searchWord) params['keyword'] = search.searchWord
      if (!!search?.searchId) params['searchId'] = search?.searchId
      setFilterParams({ ...params })
    // }, 1000)

    // return () => clearTimeout(timeoutId)
  }, [active, search])

   
  return (
    <React.Fragment>
      <div className='page-content'>
        <MetaTags>
          <title>Countries</title>
        </MetaTags>
        <Container fluid >
          <Row className="mb-1">
            <Col md={6}>
              <h4>Countries</h4>
            </Col>
          </Row>
          <Row>
            <Col md={3}>
              <div className="form-group has-search">
                <span className="fa fa-search form-control-feedback"></span>
                <input type="text"
                 className="form-control"
                  placeholder="Search by Countries Name"
                   onChange={(e) => OnSearchChange(e)}
                  value={search?.searchWord} />
              </div>
            </Col>
            <Col md={3}>
              <div className="form-group has-search">
                <span className="fa fa-search form-control-feedback"></span>
                <input type="text" className="form-control" placeholder="Search by ID" onChange={(e) => OnSearchIdChange(e)}
                  value={search?.searchId} />
              </div>
            </Col>
            {isExist("setting.add") ? <Col md={6}>
              <div className="d-md-flex justify-content-md-end mb-2">
                <button className="btn btn-success btnHeight px-4" onClick={addHandler}>Add New Country</button>
              </div>
            </Col>:null}
          </Row>
          <Row >
            <Col sm={6} className="my-4">
              <button
                className="btn btnHeight me-2 px-4"
                style={{
                  background: active == "all" ? "#556ee6" : "#f4f4f4",
                  color: active == "all" ? "#FFF" : "#495057"
                }}
                onClick={() => {
                  setActive("all")
                }}
              >
                All
             </button>
              <button
                className="btn btnHeight me-2 px-4"
                style={{
                  background: active == "active" ? "#556ee6" : "#f4f4f4",
                  color: active == "active" ? "#FFF" : "#495057"
                }}
                onClick={() => {
                  setActive("active")
                }}
              >
                Active
              </button>
              <button
                className="btn btnHeight me-2 px-4"
                style={{
                  background: active == "deactive" ? "#556ee6" : "#f4f4f4",
                  color: active == "deactive" ? "#FFF" : "#495057"
                }}
                onClick={() => {
                  setActive("deactive")
                }}
              >
                Deactive
              </button>
            </Col>
          </Row>
          <div>
            <Card className="w-100 ">
              <CardBody>
                <div className='py-3'>
                  <div>
                    <div className="table-responsive">
                      <Table>
                        <thead>
                          <tr className='bgHeaderTable'>
                            <th className='font-size-16'>I.D</th>
                            <th className='font-size-16'>Name</th>
                            <th className='font-size-16'>Status</th>
                            {/* <th className='font-size-16'>City</th> */}
                            <th className='font-size-16'></th>

                          </tr>
                        </thead>
                        <tbody>

                          {list.map((item, index) => {
                            return <CardItem
                              key={index}
                              index={index}
                              {...item}
                              item={item}
                              setAdd={() => setAdd()}
                              setEditObj={setEditObj}
                              toggleModal={toggle}
                              Service={CountriesService}
                              setShouldGetData={setShouldGetData}
                              searchId={search?.searchId}
                              pageNum={pageNum}
                            />
                          })}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
            <Row className="d-flex justify-content-end">
              <Col className="d-flex justify-content-between" md={12} sm={12}>
                <SystemPaginator
                  service={countriesService}
                  pageOptions={pageOptions}
                  setData={(data) =>setList([...data])}
                  setPageOptions={setPageOptions}
                  filtersParams={filtersParams}
                  shouldGetData={shouldGetData}
                  setShouldGetData={setShouldGetData}
                  setPageNum={setPageNum}
                />
              </Col>
            </Row>
          </div>

        </Container>
      </div>
      {modal && (
        <ModalForm
          modal={modal}
          toggle={toggle}
          isAdd={add}
          editObj={editObj}
          setList={setList}
          Service={CountriesService}
          type="Country"
          setShouldGetData={setShouldGetData}

        />
      )}
    </React.Fragment>
  )
}

export default CountriesPage;
